import React from 'react';
import './PrivacyPolicy.css';

function TermsAndConditions() {
  return <div class="privacy-policy">
    <h2>Terms and Conditions</h2>

    <p>Welcome to HalalCred! These Terms and Conditions ("Terms") govern your access to and use of the website and services provided by HalalCred LLC ("HalalCred," "we," "our," or "us"). By accessing or using our website and services, you agree to these Terms. Please read them carefully. If you do not agree with any part of these Terms, you should not use our website or services.</p>

    <h3>1. Use of the Website</h3>
    <p>You are permitted to use the HalalCred website for personal, non-commercial purposes only. You agree not to use the website for any illegal or unauthorized purposes and to comply with all applicable laws and regulations.</p>
    <p>We reserve the right to modify, suspend, or terminate your access to the website at any time, without notice, for conduct that we believe violates these Terms, our policies, or is harmful to other users or us.</p>

    <h3>2. Eligibility</h3>
    <p>To access certain parts of our website or apply for co-ownership or investment opportunities, you may be required to provide personal information. You agree to provide accurate and complete information and update it as necessary.</p>

    <h3>3. Loan & Halal Banking Product Listings</h3>
    <p>HalalCred is a platform that lists halal financial products, including halal loans and banking solutions. We do not provide financial products directly but connect users with partner banks and financial institutions that offer these services. When you click on “Apply Now,” you will be redirected to the respective partner’s website to complete your application. HalalCred is not responsible for the approval process or terms set by partner institutions.</p>

    <h3>3.2 Third-Party Offers</h3>
    <p>We do not guarantee that you will receive offers for any particular type of financial product or that you will meet the eligibility criteria for a specific offer. Your decision to apply for a product is entirely voluntary, and we will never submit an application to a partner on your behalf without your explicit consent.</p>

    <h3>3.3 Educational Purposes</h3>
    <p>All content and financial insights provided on HalalCred’s platform are for educational purposes only. We do not provide financial, legal, or investment advice. Additionally, we do not guarantee that the information we present, such as credit reports or credit scores, matches the criteria used by financial institutions to assess your eligibility for products or services.</p>


    <h3>4. No Financial Advice</h3>
    <p>The information provided on the HalalCred website, including blog posts and FAQs, is for informational purposes only and should not be considered financial, legal, or investment advice. Please consult a qualified professional before making any financial decisions.</p>

    <h3>5. Privacy</h3>
    <p>Your use of the HalalCred website is governed by our <a href="/privacy-policy">Privacy Policy</a>, which explains how we collect, use, and protect your personal information.</p>

    <h3>6. Intellectual Property</h3>
    <p>All content on the HalalCred website, including text, graphics, logos, and software, is our exclusive property and protected by intellectual property laws.</p>

    <h3>7. Third-Party Links</h3>
    <p>Our website may contain links to third-party websites. We are not responsible for their content, policies, or actions.</p>

    <h3>8. Limitation of Liability</h3>
    <p>To the extent permitted by law, HalalCred and its affiliates are not liable for any direct, indirect, or incidental damages arising from the use of our website or services.</p>

    <h3>9. Indemnification</h3>
    <p>You agree to indemnify and hold harmless HalalCred and its affiliates from any claims or damages resulting from your use of our website.</p>

    <h3>10. Modifications to the Terms</h3>
    <p>We reserve the right to modify these Terms at any time. Updates will be posted on this page with a revised “Last Updated” date.</p>

    <h3>11. Governing Law</h3>
    <p>These Terms are governed by the laws of the State of Washington. Any disputes will be resolved in the courts of Spokane, Washington.</p>

    <h3>12. Contact Us</h3>
    <p>If you have any questions about these Terms, please contact us at:</p>
    <p>
      <strong>HalalCred LLC</strong><br />522 W RIVERSIDE AVE STE N, SPOKANE, WA, 99201-0581, UNITED STATES<br />Email: <a href="mailto:salaam@halalcred.com">salaam@halalcred.com</a>
    </p>
  </div>;
}

export default TermsAndConditions;
